import '@fancyapps/fancybox';
import 'slick-carousel';

class Showcase {
	constructor($el) {
		this.$el = $el;
		this.$slider = this.$el.find('.showcase__gallery.slider');
		this.$videoPlay = this.$el.find('.showcase__video');
	
		this.init();
	}

	init() {
		this.slider();
		this.videoPlay();
		this.videoRatio();
	}

	slider() {
		if (typeof this.$slider === "undefined") {
			return;
		}

		if (this.$slider.find('> div').length <= 1) {
			return;
		}

		this.$slider.slick({
			adaptiveHeight: true,
			fade: true,
			speed: 500,
			arrows: true,
			dots: false,
			infinite: true,
			mobileFirst: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			pauseOnFocus: false,
			swipe: false,
		});
	}

	videoPlay() {
		const videoContainer = this.$el.find('.showcase__embed iframe');
		this.$videoPlay.on('click', () => {
			this.$videoPlay.addClass('active');

			const iframe = videoContainer[0];
			if (iframe) {
			  let src = iframe.getAttribute('src');
			  const url = new URL(src);
		
			  if (!src.includes('autoplay=1')) {
				url.searchParams.append('autoplay', 1);
				url.searchParams.append('mute', 1);
				src =url;
				iframe.setAttribute('src', src);
			  }
			}
		});
	}

	videoRatio() {
		const videoElement = this.$el.find('.showcase__video');
		const aspectRatio = videoElement.css('aspect-ratio');

		if (aspectRatio) {
			const [width, height] = aspectRatio.split('/').map(Number);
			const paddingBottom = (height / width) * 100 + '%';
			this.$el.find('.showcase__embed').css('padding-bottom', paddingBottom);
		}
	}
}

export default Showcase;